import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ResultCoursesAll from '@/pages/results/courses-all/ResultCoursesAll.vue'
import ResultCoursesStudents from '@/pages/results/courses-students/ResultCoursesStudents.vue'
import ResultCoursesCheck from '@/pages/results/courses-check/ResultCoursesCheck.vue'

export default [
  {
    name: 'results',
    path: '/results',
    meta: {
      title: 'Результаты - Школа Летово',
    },
    component: DefaultLayout,
    children: [
      {
        name: 'results-exam',
        path: 'exam',
        component: DefaultLayout,
        meta: {
          title: 'Экзамен - Школа Летово',
        },
      },
      {
        name: 'results-courses',
        path: 'courses',
        component: DefaultLayout,
        redirect: { name: 'results-courses-list' },
        meta: {
          title: 'Курсы - Школа Летово',
        },
        children: [
          {
            name: 'results-courses-list',
            path: 'list',
            component: ResultCoursesAll,
            meta: {
              title: 'Результаты по курсам - Школа Летово',
            },
          },
          {
            name: 'results-courses-student-list',
            path: 'student-list',
            component: ResultCoursesStudents,
            meta: {
              title: 'Результаты курсов по студентам - Школа Летово',
            },
          },
          {
            name: 'results-courses-check-list',
            path: 'check-list',
            component: ResultCoursesCheck,
            meta: {
              title: 'Управление проверкой урока - Школа Летово',
            },
          },
        ],
      },
      {
        name: 'results-all',
        path: 'all',
        component: DefaultLayout,
        meta: {
          title: 'Сводные результаты - Школа Летово',
        },
      },
    ],
  },
]
